module.exports = __webpack_public_path__ + "static/media/MaskGroup26.7be163ab.png";